"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _OrderBookComponent = _interopRequireDefault(require("../OrderBookComponents/OrderBookComponent"));
var _numberFormatter = require("../../helpers/numberFormatter");
var _futuresOrdersSelectors = require("../../redux/futures/selectors/futuresOrdersSelectors");
var _futuresOrderFormActions = require("../../redux/futures/actions/futuresOrderFormActions");
var _decimalPlacesHelper = require("../../helpers/decimalPlaces/decimalPlacesHelper");
var _selectors = require("../../redux/futures/selectors");
var _actions = require("../../redux/futures/actions");
var _FuturesSpreadRow = require("./FuturesSpreadRow");
var _config = _interopRequireDefault(require("../../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state) {
  var _config$TradingLayout, _config$TradingLayout2;
  var selectedInstrument = (0, _selectors.futuresSelectedInstrumentSelector)(state);
  var selectedInstrumentId = selectedInstrument === null || selectedInstrument === void 0 ? void 0 : selectedInstrument.InstrumentId;
  var decimalPlaces = state.apexCore.product.decimalPlaces;
  var fetching = (0, _futuresOrdersSelectors.futuresLevel2LoadingSelector)(state);
  var filter = {
    filterMode: 'selectedInstrument'
  };
  var level2 = (0, _futuresOrdersSelectors.futuresLevel2Selector)(state, filter);
  var openOrders = (0, _futuresOrdersSelectors.futuresOpenOrdersSelector)(state);
  var buyOpenOrders = (0, _futuresOrdersSelectors.futuresBuyOpenOrdersSelector)(state);
  var sellOpenOrders = (0, _futuresOrdersSelectors.futuresSellOpenOrdersSelector)(state);
  var spread = (0, _futuresOrdersSelectors.futuresSpreadSelector)(state, filter);
  var convertedQuantityIncrement = selectedInstrumentId ? (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(selectedInstrument.QuantityIncrement) : 2;
  var convertedPriceIncrement = selectedInstrumentId ? (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(selectedInstrument.PriceIncrement) : 2;
  return {
    level2: level2,
    spread: (0, _numberFormatter.formatNumberToLocale)(spread, selectedInstrumentId ? (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(selectedInstrument.PriceIncrement) : 2),
    decimalPlaces: decimalPlaces,
    fetching: fetching,
    selectedInstrumentId: selectedInstrumentId,
    openOrders: openOrders,
    buyOpenOrders: buyOpenOrders,
    sellOpenOrders: sellOpenOrders,
    selectedInstrument: selectedInstrument,
    convertedQuantityIncrement: convertedQuantityIncrement,
    convertedPriceIncrement: convertedPriceIncrement,
    SpreadComponent: _FuturesSpreadRow.FuturesSpreadRow,
    showAccumulatedSum: (_config$TradingLayout = (_config$TradingLayout2 = _config["default"].TradingLayout) === null || _config$TradingLayout2 === void 0 ? void 0 : _config$TradingLayout2.showAccumulatedSum) !== null && _config$TradingLayout !== void 0 ? _config$TradingLayout : false
  };
};
var mapDispatchToProps = {
  cancelAllOrders: _actions.cancelAllFuturesOrders,
  cancelBuyOrders: _actions.cancelBuyFuturesOrders,
  cancelSellOrders: _actions.cancelSellFuturesOrders,
  cancelOrders: _actions.cancelFuturesOrders,
  buyQuantityClicked: function buyQuantityClicked(e) {
    return (0, _futuresOrderFormActions.buyQuantityClicked)(e.currentTarget.dataset);
  },
  buyPriceClicked: function buyPriceClicked(e) {
    return (0, _futuresOrderFormActions.buyPriceClicked)(e.currentTarget.dataset);
  },
  sellQuantityClicked: function sellQuantityClicked(e) {
    return (0, _futuresOrderFormActions.sellQuantityClicked)(e.currentTarget.dataset);
  },
  sellPriceClicked: function sellPriceClicked(e) {
    return (0, _futuresOrderFormActions.sellPriceClicked)(e.currentTarget.dataset);
  }
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_OrderBookComponent["default"]);